import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  public: 'files/public',
  private: 'files/private',
  upload: 'files/upload',
  myDocuments: 'files/my-documents',
  userDocuments: 'files/user-documents',
  projectDocuments: 'files/project-documents',
  delete: 'files',
  sendMail: 'files/sendMail',
};

const DocumentsService = {
  public: async (paths: string) => RequestService.get(endpoints.public, { params: { paths } }),
  private: async (paths: string) => RequestService.get(endpoints.private, { params: { paths } }),
  projectDocuments: async (projectId: number) => RequestService.get(`${endpoints.projectDocuments}/${projectId}`),
  deleteDocument: async (id: number | string) => RequestService.delete(`${endpoints.delete}/${id}`),
  myDocuments: async () => RequestService.get(endpoints.myDocuments),
  userDocuments: async (userId: string | number) => RequestService.get(`${endpoints.userDocuments}/${userId}`),
  upload: async (formData: FormData) => RequestService.post(endpoints.upload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  sendMail: async (data: { file_id: string; user_id: number }) => RequestService.post(endpoints.sendMail, data),
};

export default DocumentsService;
